import type { ExpenseManagementTypes } from "@/redux/expenseManagement/expenseManagementTypes";

export const initialState: ExpenseManagementTypes = {
  fetching: false,
  statusCode: null,
  error: null,
  success: null,
};
